// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import InterviewDesignController from "./interview_design_controller"
application.register("interview-design", InterviewDesignController)

import JsonEditorController from "./json_editor_controller"
application.register("json-editor", JsonEditorController)

import LogFilterController from "./log_filter_controller"
application.register("log-filter", LogFilterController)

import AutoRefreshController from "./auto_refresh_controller"
application.register("auto-refresh", AutoRefreshController)

import VideoPlayerController from "./video_player_controller"
application.register("video-player", VideoPlayerController)

import TrendChartController from "./trend_chart_controller"
application.register("trend-chart", TrendChartController)

import ExportModalController from "./export_modal_controller"
application.register("export-modal", ExportModalController)
